module.exports = __webpack_public_path__ + "static/CRS_02_new-6721d8ba51b9867e2a43f82c851f6114.svg";